import axios from "axios";
import { TParamsUser } from "./UserManagement";

export const getContactsApi = (params?: TParamsUser) => {
  return axios.get("/contacts", { params });
};
